import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { LogoConfig, NavigationService } from '../../core/navigation/navigation.service';

@Component({
  selector: 'lib-not-found-authenticated',
  imports: [CommonModule, RouterLink, TranslatePipe],
  templateUrl: './not-found-authenticated.component.html',
  styleUrl: './not-found-authenticated.component.css',
  standalone: true,
})
export class NotFoundAuthenticatedComponent implements OnInit, OnDestroy {
  @Input() logo: LogoConfig = {
    type: 'image',
    src: 'https://angular.io/assets/images/logos/angular/angular.svg',
    alt: 'Angular Logo',
  };
  @Input() appName = 'Angular';
  @Input() backgroundColor = 'bg-white';
  @Input() primaryColor = 'text-primary-600';
  @Input() decorativeImage?: string;

  private readonly destroy$ = new Subject<void>();
  private translateService = inject(TranslateService);
  private navigationService = inject(NavigationService);

  ngOnInit() {
    if (!this.translateService.currentLang) {
      this.translateService.setDefaultLang('es');
      this.translateService.use('es');
    }
    if (!this.logo || this.logo.type === 'image') {
      this.navigationService.logoChanges.pipe(takeUntil(this.destroy$)).subscribe((logo) => {
        if (logo) {
          this.logo = logo;
        }
      });
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
